import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import { Form, FormFeedback, Input } from 'reactstrap';
import { Offsymbol, OnSymbol } from '../../../constants/holcim';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseSelectComponent } from '../../../shared';

// Formik formikFormData
import { useFormik } from "formik";
import * as Yup from "yup";

export const LabRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, labTypes, modalClose }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal])

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            laboratoryType: isUpdate ? rowInfo.laboratoryType.id : null,
        },
        validationSchema: isUpdate ? Yup.object({
            name: Yup.string().required("Ingrese el nombre del laboratorio"),
        }) : Yup.object({
            name: Yup.string().required("Ingrese el nombre del laboratorio"),
            laboratoryType: Yup.string().required("Seleccione un tipo de laboratorio"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(!showModal);
    }
    const children_form = (
        <div>
            <h4 class="text-primary m-0 ps-4">Registro/Actualización de Laboratorios Citec/Móvil</h4>

            <GradientDecorationLine />

            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    formikFormData.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de Laboratorio</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Nombre de Laboratorio"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.name || ""}
                        invalid={
                            formikFormData.touched.name && formikFormData.errors.name ? true : false
                        }
                    />
                    {formikFormData.touched.name && formikFormData.errors.name ? (
                        <FormFeedback type="invalid">{formikFormData.errors.name}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de Laboratorio</label>
                    <BaseSelectComponent
                        options={labTypes.map((labType)=>({value: labType.id, label: labType.name}))}
                        value={formikFormData.values.laboratoryType}
                        onChange={(value)=>{formikFormData.setFieldValue('laboratoryType', value)}}
                        error="Seleccione tipo de laboratorio"
                        touched={formikFormData.errors.laboratoryType && formikFormData.touched.laboratoryType}
                        placeholder="Seleccione tipo de laboratorio"
                        status={formikFormData.errors.laboratoryType && formikFormData.touched.laboratoryType ? 'error' : ''}
                    />
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => { onClosed() }}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <>
            <BaseCustomModal
                isModalOpen={showModal}
                handleOk={() => { onClosed() }}
                handleCancel={() => { onClosed() }}
                footer={null}
                children={children_form}
                width={700}
            />
        </>
    )

}
